// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r3-c";
export var backButton = "_r3-4";
export var backIcon = "_r3-5";
export var chevronShortcut = "_r3-6";
export var container = "_r3-1";
export var editor = "_r3-8";
export var editorWrapper = "_r3-7";
export var prefix = "_r3-2";
export var searchIcon = "_r3-3";
export var suffix = "_r3-9";
export var suffixContent = "_r3-a";
export var suffixText = "_r3-b";
export var wrapper = "_r3-0";